module.exports = __webpack_public_path__ + "static/img/page02-banner.e4b30c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/page02-banner.jpg
// module id = B6nr
// module chunks = 0